import { Outlet, createRootRouteWithContext, Link } from "@tanstack/react-router";
import { Toaster } from "sonner";
import { EmptyState, Button } from "../components/ui";
import type { RouterContext } from "../router-context";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <Outlet />
      <Toaster richColors position="top-right" closeButton />
    </>
  ),
  notFoundComponent: () => (
    <main className="flex min-h-full items-center justify-center">
      <EmptyState
        title="Page not found"
        description="The page you're looking for doesn't exist or you don't have access to it."
        action={
          <Button asChild variant="secondary">
            <Link to="/">Go home</Link>
          </Button>
        }
      />
    </main>
  ),
});
